import { render, staticRenderFns } from "./screenfull.vue?vue&type=template&id=6bdbc650&scoped=true&"
import script from "./screenfull.vue?vue&type=script&lang=js&"
export * from "./screenfull.vue?vue&type=script&lang=js&"
import style0 from "./screenfull.vue?vue&type=style&index=0&id=6bdbc650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdbc650",
  null
  
)

export default component.exports